import React, { useCallback } from 'react';
import {
  Upload as AntdUpload,
  Button,
  Space,
  Typography,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import { Preview } from './preview';
import styles from './styles.module.less';
import { InputWrap } from '../input-wrap';
import { useTextField } from 'src/hooks/use-text-field';

const MAX_FILES_COUNT = 5;

export function Upload({ name }) {
  const [field, , helpers] = useField(name);
  const { t } = useTranslation();
  const { setValue, setTouched } = helpers;
  const [
    value,
    {
      hasError,
      handleOnChange,
      handleBlur,
      error,
    },
  ] = useTextField(name);

  const { value: fileList } = field;

  const onChange = useCallback(({ fileList: newFileList }) => {
    setValue(newFileList);
    setTouched(true, true);
    handleOnChange(newFileList);
  }, [setValue]);

  return (
    <div className={styles.root}>
      <InputWrap
        name={name}
        hasError={hasError}
        error={error}
        className={styles.root}
      >
        <AntdUpload
          accept="image/png, image/jpeg"
          maxCount={MAX_FILES_COUNT}
          fileList={fileList}
          className={styles.upload}
          multiple
          customRequest={({ file, onSuccess }) => onSuccess(file)}
          onChange={onChange}
          itemRender={(originNode, file, fileList, { remove }) => (
            <Preview
              file={file}
              onRemove={remove}
            />
          )}
        >
          <div
            className={styles.buttonWrap}
          >
            <Button
              className={styles.button}
              icon={<UploadOutlined />}
            >
              {t('button.upload-photo')}
            </Button>
            <Space
              direction="vertical"
              size={0}
            >
              <Typography.Text>
                {t('upload.note')}
              </Typography.Text>
              <Typography.Text type="secondary">
                {`${t('upload.files-count')}: ${MAX_FILES_COUNT}`}
              </Typography.Text>
            </Space>
          </div>
        </AntdUpload>
      </InputWrap>
    </div>
  );
}
